import type { Access, ChosenLooks } from "@app/protocol";

/**
 * What a tap on a look does (ADR 0030): select one the table may use, otherwise ask the server for
 * its trial: a Club look never tried, or one whose access has not arrived yet (the server knows, and
 * starts nothing it should not). An ended trial does nothing; a second tap while one is recorded waits. Pure.
 */
export function pickStep(
  access: Access | undefined,
  pending: boolean,
): "select" | "start-trial" | "none" {
  if (access?.kind === "free" || access?.kind === "club" || access?.kind === "trial")
    return "select";
  if (access?.kind === "ended" || pending) return "none";
  return "start-trial";
}

/** The table opens only once no trial is being recorded; before that it would open with the default. */
export function canOpen(pending: ReadonlySet<string>): boolean {
  return pending.size === 0;
}

/**
 * The scene and deck a new table opens with: the player's pick on this screen, else what they chose
 * last (review 0015 decision 118, null until the server answered), else the table's own. Pure.
 */
export function startingLooks(
  table: ChosenLooks,
  chosen: ChosenLooks | null,
  picked: Partial<ChosenLooks>,
): ChosenLooks {
  return {
    scene: picked.scene ?? chosen?.scene ?? table.scene,
    deck: picked.deck ?? chosen?.deck ?? table.deck,
  };
}
